
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import './FlightSearchCSS.css';


class FlightSearchComponent extends Component {
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';

        this.state = {
            isSpanish,
            title : isSpanish ? 'Busqueda de vuelo' : 'Flight Search',
            placeHolder: isSpanish ? 'Ingrese aerolínea, ciudad, o número de vuelo' : 'Enter Airline, City or Flight #',
            AORD : 'A',
            suggestions: [],
            input: '',
        }
    }

    debounced = (func, wait, immediate) => {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    search = this.debounced(() => {
        if (this.state.input === '') {
            this.setState(Object.assign(this.state, {suggestions: []}));
            return
        }
        fetch(`https://apps.skyharbor.com/flightinformation/search/${this.state.input}`)
            .then(response => response.json())
            .then(jResponse => this.setState(Object.assign(this.state, {suggestions: jResponse})))

    },200);

    toggleAD = (AORD) => {
        this.setState(Object.assign(this.state, {AORD}))
    };

    searchButtonPressed = (evt, item) => {
        evt.preventDefault();

        let strQuery = 'AD='+this.state.AORD;

        if (item !== '' && item !== null && item !== undefined) {
            strQuery = strQuery + "&Search=" + item;
        } else if (this.state.input !== '') {
            strQuery = strQuery + "&Search=" + this.state.input;
        }
        window.location.href = '/Results/FlightSearch?' + strQuery
    };


    render() {
        return (
            <div>

                <div className="flightsearch mx-md-0">
                    <div className="col-12 p-2">
                        <div style={{
                            background: "white",
                            color: "rgba(133, 27, 29, 1)",
                            fontSize: "1.3em",
                            fontWeight: "bold",
                            fontFamily: "Calibri, san-serif"
                        }}
                             className="col-12 pl-2 mt-2">{this.state.title}
                        </div>

                    </div>
                    <div className="col-12">
                        <div className="row">

                            <img src="/images/default-source/siteimages/iconsmenusystem/arrivals.png"
                                 onClick={() => this.toggleAD('A')}
                                 className="my-0 ml-2" style={this.state.AORD === 'A' ? {maxHeight: 100, backgroundColor:'rgba(255,255,255,.50)', borderRadius: '10px'} : {maxHeight: 100}} alt="Search"/>

                            <img src="/images/default-source/siteimages/iconsmenusystem/departures.png"
                                 onClick={() => this.toggleAD('D')}
                                 className="my-0 ml-2" style={this.state.AORD === 'D' ? {maxHeight: 100, backgroundColor:'rgba(255,255,255,.50)', borderRadius: '10px'} : {maxHeight: 100}} alt="Search"/>

                        </div>
                    </div>
                    <div className="col-12 p-2">
                        <div className="input-group">
                            <input type="text"
                                   style={{borderRadius: '10px'}}
                                   className="form-control"
                                   value={this.state.input}
                                   placeholder={this.state.placeHolder}
                                   onChange={event => {
                                       this.setState(
                                           Object.assign(this.state,
                                               {input: event.target.value}));
                                       this.search();
                                   } }
                                   onKeyPress={(k) => {
                                       console.log(k)
                                       if (k.key === 'Enter') {
                                           this.searchButtonPressed(k)
                                       }
                                   }}
                                   data-error="Please enter an airline, an airport city or flight number."
                                   aria-describedby="flight_infoError"
                                   autoComplete="off"/>
                            <div className="input-group-append">
                                <span className="input-group-text"
                                      style={{background: "transparent", border: "none", padding: "0", cursor: 'pointer'}}><img
                                    src="/images/default-source/siteimages/iconsmenusystem/search.png"
                                    onClick={(e) => this.searchButtonPressed(e)}

                                    style={{maxHeight: 41}} alt="Search"/></span>

                            </div>
                        </div>
                        <ul style={{
                            position: 'absolute',
                            background: 'white',
                            width: '100%',
                            left: '0',
                            right: '0',
                            marginLeft: '0',
                            marginRight: '0',
                            listStyle: 'none',
                            zIndex: '1'
                        }}>

                        </ul>
                    </div>

                </div>
            </div>

        );
    }
}


let domContainer = document.querySelector('#flightsearchmain');
if (!(domContainer === undefined || domContainer === null) === true )  ReactDOM.render(<FlightSearchComponent/>, domContainer);
